import type { State } from '@/state';
import type { FilterOption } from './option';
import { getFilterAllOption } from './function';

interface SectionCategory {
    id: number,
    child: SectionFilter[]
}

interface SectionFilter {
    id: number,
    name: string,
    lat: string,
    lng: string
}

const SECTION: SectionCategory[] = [{
    id: 1,
    child: [{
        id: 5,
        name: "大安區",
        lat: "25.0249441",
        lng: "121.5433783"
    }, {
        id: 10,
        name: "內湖區",
        lat: "25.0689422",
        lng: "121.5909027"
    }, {
        id: 8,
        name: "士林區",
        lat: "25.0950492",
        lng: "121.5246077"
    }, {
        id: 12,
        name: "文山區",
        lat: "24.9929212",
        lng: "121.5712500"
    }, {
        id: 9,
        name: "北投區",
        lat: "25.1151759",
        lng: "121.5150180"
    }, {
        id: 3,
        name: "中山區",
        lat: "25.0792018",
        lng: "121.5427093"
    }, {
        id: 7,
        name: "信義區",
        lat: "25.0409201",
        lng: "121.5720055"
    }, {
        id: 4,
        name: "松山區",
        lat: "25.0541591",
        lng: "121.5638621"
    }, {
        id: 6,
        name: "萬華區",
        lat: "25.0262857",
        lng: "121.4970294"
    }, {
        id: 1,
        name: "中正區",
        lat: "25.0421407",
        lng: "121.5198716"
    }, {
        id: 2,
        name: "大同區",
        lat: "25.0627243",
        lng: "121.5113064"
    }, {
        id: 11,
        name: "南港區",
        lat: "25.0312347",
        lng: "121.6111949"
    }]
}, {
    id: 2,
    child: [{
        id: 17,
        name: "安樂區",
        lat: "25.1474144",
        lng: "121.7024448"
    }, {
        id: 14,
        name: "信義區",
        lat: "25.1284336",
        lng: "121.7822278"
    }, {
        id: 19,
        name: "七堵區",
        lat: "25.1143924",
        lng: "121.6853410"
    }, {
        id: 15,
        name: "中正區",
        lat: "25.1489988",
        lng: "121.7736823"
    }, {
        id: 16,
        name: "中山區",
        lat: "25.1525870",
        lng: "121.7252457"
    }, {
        id: 13,
        name: "仁愛區",
        lat: "25.1187161",
        lng: "121.7451927"
    }, {
        id: 18,
        name: "暖暖區",
        lat: "25.0836163",
        lng: "121.7480420"
    }]
}, {
    id: 3,
    child: [{
        id: 26,
        name: "板橋區",
        lat: "25.0114095",
        lng: "121.4618415"
    }, {
        id: 44,
        name: "新莊區",
        lat: "25.0265985",
        lng: "121.4178347"
    }, {
        id: 38,
        name: "中和區",
        lat: "24.9962178",
        lng: "121.4853103"
    }, {
        id: 43,
        name: "三重區",
        lat: "25.0614534",
        lng: "121.4867114"
    }, {
        id: 34,
        name: "新店區",
        lat: "24.9782820",
        lng: "121.5394822"
    }, {
        id: 39,
        name: "土城區",
        lat: "24.9683710",
        lng: "121.4380340"
    }, {
        id: 37,
        name: "永和區",
        lat: "25.0103251",
        lng: "121.5145353"
    }, {
        id: 27,
        name: "汐止區",
        lat: "25.0616059",
        lng: "121.6397184"
    }, {
        id: 47,
        name: "蘆洲區",
        lat: "25.0868908",
        lng: "121.4715241"
    }, {
        id: 50,
        name: "淡水區",
        lat: "25.1719805",
        lng: "121.4433706"
    }, {
        id: 41,
        name: "樹林區",
        lat: "24.9815605",
        lng: "121.4198606"
    }, {
        id: 46,
        name: "林口區",
        lat: "25.0790108",
        lng: "121.3881378"
    }, {
        id: 40,
        name: "三峽區",
        lat: "24.9358605",
        lng: "121.3744903"
    }, {
        id: 48,
        name: "五股區",
        lat: "25.0848317",
        lng: "121.4386586"
    }, {
        id: 42,
        name: "鶯歌區",
        lat: "24.9614967",
        lng: "121.3427262"
    }, {
        id: 45,
        name: "泰山區",
        lat: "25.0581641",
        lng: "121.4327919"
    }, {
        id: 49,
        name: "八里區",
        lat: "25.1443896",
        lng: "121.3983016"
    }, {
        id: 30,
        name: "瑞芳區",
        lat: "25.1030520",
        lng: "121.8220980"
    }, {
        id: 28,
        name: "深坑區",
        lat: "25.0033792",
        lng: "121.6169002"
    }, {
        id: 51,
        name: "三芝區",
        lat: "25.2593452",
        lng: "121.5024341"
    }, {
        id: 20,
        name: "萬里區",
        lat: "25.1676024",
        lng: "121.6397184"
    }, {
        id: 21,
        name: "金山區",
        lat: "25.2223616",
        lng: "121.6367773"
    }, {
        id: 33,
        name: "貢寮區",
        lat: "25.0168762",
        lng: "121.9459786"
    }, {
        id: 52,
        name: "石門區",
        lat: "25.2908277",
        lng: "121.5671383"
    }, {
        id: 32,
        name: "雙溪區",
        lat: "24.9971842",
        lng: "121.8220980"
    }, {
        id: 29,
        name: "石碇區",
        lat: "25.0098662",
        lng: "121.6452827"
    }, {
        id: 35,
        name: "坪林區",
        lat: "24.9350844",
        lng: "121.7107613"
    }, {
        id: 36,
        name: "烏來區",
        lat: "24.8663721",
        lng: "121.5497801"
    }, {
        id: 31,
        name: "平溪區",
        lat: "25.0248314",
        lng: "121.7408654"
    }]
}, {
    id: 4,
    child: [{
        id: 371,
        name: "東區",
        lat: "24.8015877",
        lng: "120.9715883"
    }, {
        id: 372,
        name: "北區",
        lat: "24.8042436",
        lng: "120.9661470"
    }, {
        id: 370,
        name: "香山區",
        lat: "24.7798216",
        lng: "120.9302603"
    }]
}, {
    id: 5,
    child: [{
        id: 54,
        name: "竹北市",
        lat: "24.8346871",
        lng: "120.9933678"
    }, {
        id: 61,
        name: "竹東鎮",
        lat: "24.7749220",
        lng: "121.0449768"
    }, {
        id: 55,
        name: "湖口鄉",
        lat: "24.8814458",
        lng: "121.0449768"
    }, {
        id: 56,
        name: "新豐鄉",
        lat: "24.9132859",
        lng: "120.9991032"
    }, {
        id: 57,
        name: "新埔鎮",
        lat: "24.8496061",
        lng: "121.0908329"
    }, {
        id: 58,
        name: "關西鎮",
        lat: "24.8044851",
        lng: "121.1481284"
    }, {
        id: 59,
        name: "芎林鄉",
        lat: "24.7657920",
        lng: "121.1080244"
    }, {
        id: 60,
        name: "寶山鄉",
        lat: "24.7427912",
        lng: "120.9991032"
    }, {
        id: 63,
        name: "橫山鄉",
        lat: "24.7113011",
        lng: "121.1366715"
    }, {
        id: 64,
        name: "尖石鄉",
        lat: "24.5760667",
        lng: "121.3084088"
    }, {
        id: 65,
        name: "北埔鄉",
        lat: "24.6631393",
        lng: "121.0679070"
    }, {
        id: 66,
        name: "峨嵋鄉",
        lat: "24.6783629",
        lng: "120.9851227"
    }, {
        id: 62,
        name: "五峰鄉",
        lat: "24.5915441",
        lng: "121.1481284"
    }]
}, {
    id: 6,
    child: [{
        id: 73,
        name: "桃園區",
        lat: "24.9553806",
        lng: "121.2300015"
    }, {
        id: 67,
        name: "中壢區",
        lat: "24.9721514",
        lng: "121.2053963"
    }, {
        id: 68,
        name: "平鎮區",
        lat: "24.9296022",
        lng: "121.2053963"
    }, {
        id: 75,
        name: "八德區",
        lat: "24.9469059",
        lng: "121.2912463"
    }, {
        id: 70,
        name: "楊梅區",
        lat: "24.9242108",
        lng: "121.1366715"
    }, {
        id: 74,
        name: "龜山區",
        lat: "25.0199092",
        lng: "121.3655989"
    }, {
        id: 79,
        name: "蘆竹區",
        lat: "25.0784359",
        lng: "121.2969674"
    }, {
        id: 69,
        name: "龍潭區",
        lat: "24.8444927",
        lng: "121.2053963"
    }, {
        id: 76,
        name: "大溪區",
        lat: "24.8658422",
        lng: "121.2969674"
    }, {
        id: 78,
        name: "大園區",
        lat: "25.0492632",
        lng: "121.1939450"
    }, {
        id: 72,
        name: "觀音區",
        lat: "25.0359365",
        lng: "121.1137544"
    }, {
        id: 71,
        name: "新屋區",
        lat: "24.9826597",
        lng: "121.0679070"
    }, {
        id: 77,
        name: "復興區",
        lat: "24.7090890",
        lng: "121.3770336"
    }]
}, {
    id: 7,
    child: [{
        id: 81,
        name: "頭份市",
        lat: "24.6884438",
        lng: "120.9024836"
    }, {
        id: 80,
        name: "竹南鎮",
        lat: "24.7009219",
        lng: "120.8786026"
    }, {
        id: 88,
        name: "苗栗市",
        lat: "24.5711502",
        lng: "120.8154358"
    }, {
        id: 87,
        name: "苑裡鎮",
        lat: "24.4098262",
        lng: "120.6775054"
    }, {
        id: 85,
        name: "後龍鎮",
        lat: "24.6144348",
        lng: "120.7906035"
    }, {
        id: 86,
        name: "通霄鎮",
        lat: "24.4892617",
        lng: "120.6803783"
    }, {
        id: 91,
        name: "公館鄉",
        lat: "24.5111399",
        lng: "120.8211796"
    }, {
        id: 94,
        name: "銅鑼鄉",
        lat: "24.4481942",
        lng: "120.7924580"
    }, {
        id: 97,
        name: "卓蘭鎮",
        lat: "24.3113039",
        lng: "120.8254872"
    }, {
        id: 95,
        name: "三義鄉",
        lat: "24.3892633",
        lng: "120.7694760"
    }, {
        id: 92,
        name: "大湖鄉",
        lat: "24.3980966",
        lng: "120.8728615"
    }, {
        id: 89,
        name: "造橋鄉",
        lat: "24.6248068",
        lng: "120.8613785"
    }, {
        id: 90,
        name: "頭屋鄉",
        lat: "24.5765856",
        lng: "120.8545433"
    }, {
        id: 83,
        name: "南庄鄉",
        lat: "24.5802942",
        lng: "121.0105733"
    }, {
        id: 96,
        name: "西湖鄉",
        lat: "24.5567613",
        lng: "120.7570814"
    }, {
        id: 82,
        name: "三灣鄉",
        lat: "24.6305288",
        lng: "120.9302603"
    }, {
        id: 93,
        name: "泰安鄉",
        lat: "24.3831955",
        lng: "121.0335100"
    }, {
        id: 84,
        name: "獅潭鄉",
        lat: "24.5238661",
        lng: "120.9302603"
    }]
}, {
    id: 8,
    child: [{
        id: 103,
        name: "北屯區",
        lat: "24.1815237",
        lng: "120.6861019"
    }, {
        id: 104,
        name: "西屯區",
        lat: "24.1769764",
        lng: "120.6424333"
    }, {
        id: 107,
        name: "大里區",
        lat: "24.1046899",
        lng: "120.6812114"
    }, {
        id: 106,
        name: "太平區",
        lat: "24.1240719",
        lng: "120.7170701"
    }, {
        id: 105,
        name: "南屯區",
        lat: "24.1471183",
        lng: "120.6084832"
    }, {
        id: 110,
        name: "豐原區",
        lat: "24.2521213",
        lng: "120.7234816"
    }, {
        id: 102,
        name: "北區",
        lat: "24.1573171",
        lng: "120.6832556"
    }, {
        id: 100,
        name: "南區",
        lat: "24.1208445",
        lng: "120.6624117"
    }, {
        id: 101,
        name: "西區",
        lat: "24.1430604",
        lng: "120.6631289"
    }, {
        id: 116,
        name: "潭子區",
        lat: "24.2163612",
        lng: "120.7062535"
    }, {
        id: 120,
        name: "沙鹿區",
        lat: "24.2377939",
        lng: "120.5854674"
    }, {
        id: 117,
        name: "大雅區",
        lat: "24.2225023",
        lng: "120.6545022"
    }, {
        id: 123,
        name: "清水區",
        lat: "24.2754785",
        lng: "120.5713280"
    }, {
        id: 109,
        name: "烏日區",
        lat: "24.1077870",
        lng: "120.6380936"
    }, {
        id: 121,
        name: "龍井區",
        lat: "24.2101223",
        lng: "120.5057794"
    }, {
        id: 99,
        name: "東區",
        lat: "24.1427702",
        lng: "120.6944233"
    }, {
        id: 124,
        name: "大甲區",
        lat: "24.3788233",
        lng: "120.6487508"
    }, {
        id: 118,
        name: "神岡區",
        lat: "24.2499057",
        lng: "120.6817589"
    }, {
        id: 108,
        name: "霧峰區",
        lat: "24.0443180",
        lng: "120.7350013"
    }, {
        id: 122,
        name: "梧棲區",
        lat: "24.2490793",
        lng: "120.5386546"
    }, {
        id: 119,
        name: "大肚區",
        lat: "24.1358732",
        lng: "120.5624474"
    }, {
        id: 111,
        name: "后里區",
        lat: "24.3088765",
        lng: "120.7223705"
    }, {
        id: 113,
        name: "東勢區",
        lat: "24.2599898",
        lng: "120.8272085"
    }, {
        id: 125,
        name: "外埔區",
        lat: "24.3317733",
        lng: "120.6533224"
    }, {
        id: 115,
        name: "新社區",
        lat: "24.1867194",
        lng: "120.8154358"
    }, {
        id: 126,
        name: "大安區",
        lat: "24.3702355",
        lng: "120.5912217"
    }, {
        id: 98,
        name: "中區",
        lat: "24.1402601",
        lng: "120.6818181"
    }, {
        id: 112,
        name: "石岡區",
        lat: "24.2742426",
        lng: "120.7771553"
    }, {
        id: 114,
        name: "和平區",
        lat: "24.3207261",
        lng: "121.3084088"
    }]
}, {
    id: 10,
    child: [{
        id: 127,
        name: "彰化市",
        lat: "24.0716583",
        lng: "120.5624474"
    }, {
        id: 136,
        name: "員林市",
        lat: "23.9595740",
        lng: "120.5854674"
    }, {
        id: 134,
        name: "和美鎮",
        lat: "24.1122859",
        lng: "120.4983956"
    }, {
        id: 131,
        name: "鹿港鎮",
        lat: "24.0755127",
        lng: "120.4472850"
    }, {
        id: 140,
        name: "溪湖鎮",
        lat: "23.9583265",
        lng: "120.4933624"
    }, {
        id: 149,
        name: "二林鎮",
        lat: "23.9141358",
        lng: "120.4011911"
    }, {
        id: 132,
        name: "福興鄉",
        lat: "24.0377011",
        lng: "120.4242401"
    }, {
        id: 129,
        name: "花壇鄉",
        lat: "24.0288453",
        lng: "120.5624474"
    }, {
        id: 137,
        name: "社頭鄉",
        lat: "23.8992037",
        lng: "120.5827201"
    }, {
        id: 141,
        name: "大村鄉",
        lat: "23.9890696",
        lng: "120.5662224"
    }, {
        id: 143,
        name: "田中鎮",
        lat: "23.8525401",
        lng: "120.5854674"
    }, {
        id: 135,
        name: "伸港鄉",
        lat: "24.1581740",
        lng: "120.4982653"
    }, {
        id: 130,
        name: "秀水鄉",
        lat: "24.0348603",
        lng: "120.5106372"
    }, {
        id: 138,
        name: "永靖鄉",
        lat: "23.9202279",
        lng: "120.5451797"
    }, {
        id: 139,
        name: "埔心鄉",
        lat: "23.9430014",
        lng: "120.5592918"
    }, {
        id: 144,
        name: "北斗鎮",
        lat: "23.8692080",
        lng: "120.5336665"
    }, {
        id: 151,
        name: "芳苑鄉",
        lat: "23.9455949",
        lng: "120.3550808"
    }, {
        id: 142,
        name: "埔鹽鄉",
        lat: "23.9898141",
        lng: "120.4472850"
    }, {
        id: 146,
        name: "埤頭鄉",
        lat: "23.8776623",
        lng: "120.4703258"
    }, {
        id: 147,
        name: "溪州鄉",
        lat: "23.8247844",
        lng: "120.5163949"
    }, {
        id: 145,
        name: "田尾鄉",
        lat: "23.9038461",
        lng: "120.5221524"
    }, {
        id: 128,
        name: "芬園鄉",
        lat: "24.0135640",
        lng: "120.6284031"
    }, {
        id: 133,
        name: "線西鄉",
        lat: "24.1316695",
        lng: "120.4622016"
    }, {
        id: 150,
        name: "大城鄉",
        lat: "23.8483614",
        lng: "120.3089541"
    }, {
        id: 148,
        name: "竹塘鄉",
        lat: "23.8448257",
        lng: "120.4242401"
    }, {
        id: 152,
        name: "二水鄉",
        lat: "23.8115197",
        lng: "120.6160709"
    }]
}, {
    id: 11,
    child: [{
        id: 153,
        name: "南投市",
        lat: "23.9179637",
        lng: "120.6775054"
    }, {
        id: 155,
        name: "草屯鎮",
        lat: "23.9933816",
        lng: "120.7234992"
    }, {
        id: 157,
        name: "埔里鎮",
        lat: "23.9932872",
        lng: "120.9646866"
    }, {
        id: 164,
        name: "竹山鎮",
        lat: "23.7122010",
        lng: "120.6890055"
    }, {
        id: 159,
        name: "名間鄉",
        lat: "23.8537843",
        lng: "120.6775054"
    }, {
        id: 156,
        name: "國姓鄉",
        lat: "24.0564429",
        lng: "120.8728615"
    }, {
        id: 165,
        name: "鹿谷鄉",
        lat: "23.7348372",
        lng: "120.7809676"
    }, {
        id: 161,
        name: "水里鄉",
        lat: "23.7919524",
        lng: "120.8613785"
    }, {
        id: 158,
        name: "仁愛鄉",
        lat: "24.0213745",
        lng: "121.1252135"
    }, {
        id: 163,
        name: "信義鄉",
        lat: "23.6679756",
        lng: "120.9876321"
    }, {
        id: 162,
        name: "魚池鄉",
        lat: "23.8753852",
        lng: "120.9187827"
    }, {
        id: 154,
        name: "中寮鄉",
        lat: "23.9058666",
        lng: "120.7809676"
    }, {
        id: 160,
        name: "集集鎮",
        lat: "23.8335746",
        lng: "120.7694760"
    }]
}, {
    id: 12,
    child: [{
        id: 373,
        name: "西區",
        lat: "23.4803991",
        lng: "120.4242406"
    }, {
        id: 374,
        name: "東區",
        lat: "23.4856561",
        lng: "120.4545451"
    }]
}, {
    id: 13,
    child: [{
        id: 180,
        name: "民雄鄉",
        lat: "23.5203579",
        lng: "120.4404090"
    }, {
        id: 173,
        name: "水上鄉",
        lat: "23.4287422",
        lng: "120.4001659"
    }, {
        id: 171,
        name: "中埔鄉",
        lat: "23.3995944",
        lng: "120.5509358"
    }, {
        id: 176,
        name: "朴子市",
        lat: "23.4464152",
        lng: "120.2570421"
    }, {
        id: 175,
        name: "太保市",
        lat: "23.4964492",
        lng: "120.3837086"
    }, {
        id: 169,
        name: "竹崎鄉",
        lat: "23.5049724",
        lng: "120.6084832"
    }, {
        id: 179,
        name: "新港鄉",
        lat: "23.5381230",
        lng: "120.3550808"
    }, {
        id: 181,
        name: "大林鎮",
        lat: "23.6040709",
        lng: "120.4542004"
    }, {
        id: 184,
        name: "布袋鎮",
        lat: "23.3627901",
        lng: "120.1704766"
    }, {
        id: 177,
        name: "東石鄉",
        lat: "23.4701923",
        lng: "120.1704766"
    }, {
        id: 178,
        name: "六腳鄉",
        lat: "23.5298330",
        lng: "120.2873266"
    }, {
        id: 168,
        name: "梅山鄉",
        lat: "23.5410247",
        lng: "120.6890055"
    }, {
        id: 183,
        name: "義竹鄉",
        lat: "23.3530108",
        lng: "120.2166519"
    }, {
        id: 174,
        name: "鹿草鄉",
        lat: "23.4192570",
        lng: "120.3089541"
    }, {
        id: 182,
        name: "溪口鄉",
        lat: "23.5925564",
        lng: "120.4011911"
    }, {
        id: 167,
        name: "番路鄉",
        lat: "23.4407355",
        lng: "120.6084832"
    }, {
        id: 170,
        name: "阿里山鄉",
        lat: "23.4354677",
        lng: "120.7809676"
    }, {
        id: 172,
        name: "大埔鄉",
        lat: "23.3040182",
        lng: "120.5969758"
    }]
}, {
    id: 14,
    child: [{
        id: 194,
        name: "斗六市",
        lat: "23.7077947",
        lng: "120.5409089"
    }, {
        id: 187,
        name: "虎尾鎮",
        lat: "23.7162184",
        lng: "120.4242401"
    }, {
        id: 193,
        name: "麥寮鄉",
        lat: "23.7485306",
        lng: "120.2562662"
    }, {
        id: 198,
        name: "西螺鎮",
        lat: "23.7755286",
        lng: "120.4472850"
    }, {
        id: 185,
        name: "斗南鎮",
        lat: "23.6771369",
        lng: "120.4760808"
    }, {
        id: 200,
        name: "北港鎮",
        lat: "23.5958633",
        lng: "120.2858846"
    }, {
        id: 196,
        name: "古坑鄉",
        lat: "23.6466411",
        lng: "120.5969758"
    }, {
        id: 188,
        name: "土庫鎮",
        lat: "23.6882639",
        lng: "120.3550808"
    }, {
        id: 197,
        name: "莿桐鄉",
        lat: "23.7554232",
        lng: "120.4967222"
    }, {
        id: 202,
        name: "口湖鄉",
        lat: "23.5775853",
        lng: "120.1704766"
    }, {
        id: 199,
        name: "二崙鄉",
        lat: "23.8155793",
        lng: "120.4062196"
    }, {
        id: 204,
        name: "元長鄉",
        lat: "23.6288771",
        lng: "120.3320195"
    }, {
        id: 192,
        name: "崙背鄉",
        lat: "23.7601594",
        lng: "120.3531749"
    }, {
        id: 201,
        name: "水林鄉",
        lat: "23.5628088",
        lng: "120.2397336"
    }, {
        id: 191,
        name: "臺西鄉",
        lat: "23.7229714",
        lng: "120.1935663"
    }, {
        id: 203,
        name: "四湖鄉",
        lat: "23.6370834",
        lng: "120.1935663"
    }, {
        id: 186,
        name: "大埤鄉",
        lat: "23.6519084",
        lng: "120.4242401"
    }, {
        id: 195,
        name: "林內鄉",
        lat: "23.7618842",
        lng: "120.6084832"
    }, {
        id: 190,
        name: "東勢鄉",
        lat: "23.6932570",
        lng: "120.2570421"
    }, {
        id: 189,
        name: "褒忠鄉",
        lat: "23.6944368",
        lng: "120.3103204"
    }]
}, {
    id: 15,
    child: [{
        id: 212,
        name: "永康區",
        lat: "23.0211799",
        lng: "120.2627880"
    }, {
        id: 211,
        name: "安南區",
        lat: "23.0585336",
        lng: "120.1358346"
    }, {
        id: 206,
        name: "東區",
        lat: "22.9813300",
        lng: "120.2224227"
    }, {
        id: 209,
        name: "北區",
        lat: "23.0085150",
        lng: "120.2079953"
    }, {
        id: 207,
        name: "南區",
        lat: "22.9563522",
        lng: "120.1877943"
    }, {
        id: 208,
        name: "中西區",
        lat: "22.9948212",
        lng: "120.1964522"
    }, {
        id: 219,
        name: "仁德區",
        lat: "22.9472553",
        lng: "120.2511778"
    }, {
        id: 230,
        name: "新營區",
        lat: "23.3119567",
        lng: "120.3089541"
    }, {
        id: 210,
        name: "安平區",
        lat: "22.9934184",
        lng: "120.1647112"
    }, {
        id: 213,
        name: "歸仁區",
        lat: "22.9519268",
        lng: "120.2858846"
    }, {
        id: 224,
        name: "佳里區",
        lat: "23.1694465",
        lng: "120.1704766"
    }, {
        id: 238,
        name: "善化區",
        lat: "23.1402613",
        lng: "120.3089541"
    }, {
        id: 223,
        name: "麻豆區",
        lat: "23.1763401",
        lng: "120.2397336"
    }, {
        id: 214,
        name: "新化區",
        lat: "23.0280873",
        lng: "120.3320195"
    }, {
        id: 241,
        name: "新市區",
        lat: "23.0780281",
        lng: "120.2919179"
    }, {
        id: 220,
        name: "關廟區",
        lat: "22.9637053",
        lng: "120.3320195"
    }, {
        id: 242,
        name: "安定區",
        lat: "23.0907920",
        lng: "120.2334385"
    }, {
        id: 232,
        name: "白河區",
        lat: "23.3336369",
        lng: "120.4588059"
    }, {
        id: 225,
        name: "西港區",
        lat: "23.1257853",
        lng: "120.1993381"
    }, {
        id: 228,
        name: "學甲區",
        lat: "23.2553798",
        lng: "120.1704766"
    }, {
        id: 237,
        name: "鹽水區",
        lat: "23.2622306",
        lng: "120.2397336"
    }, {
        id: 235,
        name: "下營區",
        lat: "23.2292915",
        lng: "120.2685799"
    }, {
        id: 231,
        name: "後壁區",
        lat: "23.3665101",
        lng: "120.3550808"
    }, {
        id: 234,
        name: "六甲區",
        lat: "23.2426813",
        lng: "120.3320195"
    }, {
        id: 226,
        name: "七股區",
        lat: "23.1195166",
        lng: "120.1011836"
    }, {
        id: 222,
        name: "官田區",
        lat: "23.1948768",
        lng: "120.3550808"
    }, {
        id: 236,
        name: "柳營區",
        lat: "23.2806957",
        lng: "120.3550808"
    }, {
        id: 233,
        name: "東山區",
        lat: "23.2825014",
        lng: "120.4472850"
    }, {
        id: 227,
        name: "將軍區",
        lat: "23.2054945",
        lng: "120.1011836"
    }, {
        id: 216,
        name: "玉井區",
        lat: "23.1060822",
        lng: "120.4703258"
    }, {
        id: 229,
        name: "北門區",
        lat: "23.2866026",
        lng: "120.1242853"
    }, {
        id: 239,
        name: "大內區",
        lat: "23.1421962",
        lng: "120.4011911"
    }, {
        id: 217,
        name: "楠西區",
        lat: "23.1820152",
        lng: "120.5163949"
    }, {
        id: 218,
        name: "南化區",
        lat: "23.1079133",
        lng: "120.5624474"
    }, {
        id: 240,
        name: "山上區",
        lat: "23.0893067",
        lng: "120.3723741"
    }, {
        id: 215,
        name: "左鎮區",
        lat: "23.0300785",
        lng: "120.4242401"
    }, {
        id: 221,
        name: "龍崎區",
        lat: "22.9540045",
        lng: "120.3781380"
    }]
}, {
    id: 17,
    child: [{
        id: 268,
        name: "鳳山區",
        lat: "22.6113591",
        lng: "120.3493158"
    }, {
        id: 250,
        name: "三民區",
        lat: "22.6483444",
        lng: "120.3262535"
    }, {
        id: 253,
        name: "左營區",
        lat: "22.6877358",
        lng: "120.2916524"
    }, {
        id: 251,
        name: "楠梓區",
        lat: "22.7175372",
        lng: "120.3031871"
    }, {
        id: 249,
        name: "前鎮區",
        lat: "22.5970794",
        lng: "120.3147208"
    }, {
        id: 245,
        name: "苓雅區",
        lat: "22.6268814",
        lng: "120.3262535"
    }, {
        id: 252,
        name: "小港區",
        lat: "22.5553185",
        lng: "120.3608455"
    }, {
        id: 247,
        name: "鼓山區",
        lat: "22.6495866",
        lng: "120.2685799"
    }, {
        id: 269,
        name: "大寮區",
        lat: "22.5844810",
        lng: "120.4011911"
    }, {
        id: 254,
        name: "仁武區",
        lat: "22.7057951",
        lng: "120.3423604"
    }, {
        id: 258,
        name: "岡山區",
        lat: "22.8016472",
        lng: "120.2858846"
    }, {
        id: 270,
        name: "林園區",
        lat: "22.4986756",
        lng: "120.4011911"
    }, {
        id: 259,
        name: "路竹區",
        lat: "22.8494042",
        lng: "120.2628111"
    }, {
        id: 243,
        name: "新興區",
        lat: "22.6283893",
        lng: "120.3060706"
    }, {
        id: 271,
        name: "鳥松區",
        lat: "22.6602052",
        lng: "120.3723741"
    }, {
        id: 263,
        name: "橋頭區",
        lat: "22.7539031",
        lng: "120.3089574"
    }, {
        id: 272,
        name: "大樹區",
        lat: "22.7083710",
        lng: "120.4242401"
    }, {
        id: 274,
        name: "美濃區",
        lat: "22.8853850",
        lng: "120.5509358"
    }, {
        id: 264,
        name: "梓官區",
        lat: "22.7486104",
        lng: "120.2570421"
    }, {
        id: 273,
        name: "旗山區",
        lat: "22.8702492",
        lng: "120.4703258"
    }, {
        id: 255,
        name: "大社區",
        lat: "22.7377083",
        lng: "120.3608455"
    }, {
        id: 267,
        name: "湖內區",
        lat: "22.8954184",
        lng: "120.2224227"
    }, {
        id: 282,
        name: "茄萣區",
        lat: "22.8763476",
        lng: "120.2108809"
    }, {
        id: 262,
        name: "燕巢區",
        lat: "22.7823697",
        lng: "120.3781380"
    }, {
        id: 260,
        name: "阿蓮區",
        lat: "22.8778606",
        lng: "120.3320195"
    }, {
        id: 244,
        name: "前金區",
        lat: "22.6252508",
        lng: "120.2953492"
    }, {
        id: 248,
        name: "旗津區",
        lat: "22.6141771",
        lng: "120.2659394"
    }, {
        id: 246,
        name: "鹽埕區",
        lat: "22.6235157",
        lng: "120.2837442"
    }, {
        id: 265,
        name: "彌陀區",
        lat: "22.7832231",
        lng: "120.2455033"
    }, {
        id: 266,
        name: "永安區",
        lat: "22.8112691",
        lng: "120.2397336"
    }, {
        id: 276,
        name: "內門區",
        lat: "22.9560087",
        lng: "120.4703258"
    }, {
        id: 275,
        name: "六龜區",
        lat: "23.0026195",
        lng: "120.6545022"
    }, {
        id: 277,
        name: "杉林區",
        lat: "23.0007902",
        lng: "120.5624474"
    }, {
        id: 261,
        name: "田寮區",
        lat: "22.8633474",
        lng: "120.4011911"
    }, {
        id: 278,
        name: "甲仙區",
        lat: "23.1145920",
        lng: "120.6314948"
    }, {
        id: 279,
        name: "桃源區",
        lat: "23.2280755",
        lng: "120.8498944"
    }, {
        id: 280,
        name: "那瑪夏區",
        lat: "23.2742978",
        lng: "120.7349950"
    }, {
        id: 281,
        name: "茂林區",
        lat: "22.9319405",
        lng: "120.7349950"
    }]
}, {
    id: 19,
    child: [{
        id: 295,
        name: "屏東市",
        lat: "22.6558442",
        lng: "120.4703258"
    }, {
        id: 308,
        name: "潮州鎮",
        lat: "22.5294168",
        lng: "120.5624474"
    }, {
        id: 306,
        name: "內埔鄉",
        lat: "22.6151342",
        lng: "120.5663201"
    }, {
        id: 307,
        name: "萬丹鄉",
        lat: "22.5915220",
        lng: "120.4703258"
    }, {
        id: 316,
        name: "東港鎮",
        lat: "22.4628783",
        lng: "120.4703258"
    }, {
        id: 319,
        name: "新園鄉",
        lat: "22.4774001",
        lng: "120.4421540"
    }, {
        id: 326,
        name: "恆春鎮",
        lat: "22.0008277",
        lng: "120.7447638"
    }, {
        id: 303,
        name: "長治鄉",
        lat: "22.7008280",
        lng: "120.5624474"
    }, {
        id: 300,
        name: "里港鄉",
        lat: "22.7962363",
        lng: "120.5163949"
    }, {
        id: 302,
        name: "鹽埔鄉",
        lat: "22.7436807",
        lng: "120.5624474"
    }, {
        id: 320,
        name: "枋寮鄉",
        lat: "22.3960688",
        lng: "120.5854674"
    }, {
        id: 301,
        name: "高樹鄉",
        lat: "22.8254924",
        lng: "120.6003824"
    }, {
        id: 299,
        name: "九如鄉",
        lat: "22.7416068",
        lng: "120.4703258"
    }, {
        id: 311,
        name: "萬巒鄉",
        lat: "22.5840460",
        lng: "120.6084832"
    }, {
        id: 318,
        name: "佳冬鄉",
        lat: "22.4270780",
        lng: "120.5394232"
    }, {
        id: 315,
        name: "林邊鄉",
        lat: "22.4347039",
        lng: "120.5147274"
    }, {
        id: 305,
        name: "竹田鄉",
        lat: "22.5939138",
        lng: "120.5326679"
    }, {
        id: 312,
        name: "崁頂鄉",
        lat: "22.5158427",
        lng: "120.4991209"
    }, {
        id: 317,
        name: "琉球鄉",
        lat: "22.3535395",
        lng: "120.3732108"
    }, {
        id: 304,
        name: "麟洛鄉",
        lat: "22.6515201",
        lng: "120.5259627"
    }, {
        id: 314,
        name: "南州鄉",
        lat: "22.4747339",
        lng: "120.5163949"
    }, {
        id: 313,
        name: "新埤鄉",
        lat: "22.4817586",
        lng: "120.5854674"
    }, {
        id: 324,
        name: "車城鄉",
        lat: "22.0843074",
        lng: "120.7464897"
    }, {
        id: 296,
        name: "三地門鄉",
        lat: "22.8133088",
        lng: "120.6890055"
    }, {
        id: 310,
        name: "來義鄉",
        lat: "22.4921661",
        lng: "120.6247208"
    }, {
        id: 327,
        name: "滿州鄉",
        lat: "22.0438500",
        lng: "120.8384093"
    }, {
        id: 298,
        name: "瑪家鄉",
        lat: "22.6903584",
        lng: "120.6378794"
    }, {
        id: 309,
        name: "泰武鄉",
        lat: "22.5779544",
        lng: "120.6348032"
    }, {
        id: 321,
        name: "枋山鄉",
        lat: "22.2606439",
        lng: "120.6573779"
    }, {
        id: 322,
        name: "春日鄉",
        lat: "22.3851778",
        lng: "120.6890055"
    }, {
        id: 323,
        name: "獅子鄉",
        lat: "22.2471686",
        lng: "120.7349950"
    }, {
        id: 325,
        name: "牡丹鄉",
        lat: "22.1520217",
        lng: "120.7809676"
    }, {
        id: 297,
        name: "霧臺鄉",
        lat: "22.7509887",
        lng: "120.7809676"
    }]
}, {
    id: 21,
    child: [{
        id: 328,
        name: "宜蘭市",
        lat: "24.7591148",
        lng: "121.7537404"
    }, {
        id: 333,
        name: "羅東鎮",
        lat: "24.6755872",
        lng: "121.7708250"
    }, {
        id: 337,
        name: "冬山鄉",
        lat: "24.6319190",
        lng: "121.7537404"
    }, {
        id: 336,
        name: "五結鄉",
        lat: "24.6887633",
        lng: "121.8050125"
    }, {
        id: 338,
        name: "蘇澳鎮",
        lat: "24.5942290",
        lng: "121.8533264"
    }, {
        id: 330,
        name: "礁溪鄉",
        lat: "24.8214206",
        lng: "121.7696964"
    }, {
        id: 332,
        name: "員山鄉",
        lat: "24.7381293",
        lng: "121.6625320"
    }, {
        id: 329,
        name: "頭城鎮",
        lat: "24.8576121",
        lng: "121.8234687"
    }, {
        id: 331,
        name: "壯圍鄉",
        lat: "24.7695690",
        lng: "121.7993168"
    }, {
        id: 334,
        name: "三星鄉",
        lat: "24.6744894",
        lng: "121.6625320"
    }, {
        id: 339,
        name: "南澳鄉",
        lat: "24.4065995",
        lng: "121.6739371"
    }, {
        id: 335,
        name: "大同鄉",
        lat: "24.5498206",
        lng: "121.5141615"
    }]
}, {
    id: 22,
    child: [{
        id: 341,
        name: "臺東市",
        lat: "22.7546009",
        lng: "121.1137544"
    }, {
        id: 345,
        name: "卑南鄉",
        lat: "22.7848196",
        lng: "121.0834446"
    }, {
        id: 351,
        name: "成功鎮",
        lat: "23.1261527",
        lng: "121.3655989"
    }, {
        id: 353,
        name: "太麻里鄉",
        lat: "22.6102278",
        lng: "121.0044631"
    }, {
        id: 347,
        name: "關山鎮",
        lat: "23.0495603",
        lng: "121.1646339"
    }, {
        id: 350,
        name: "東河鄉",
        lat: "23.0691722",
        lng: "121.2855249"
    }, {
        id: 349,
        name: "池上鄉",
        lat: "23.1207330",
        lng: "121.2161784"
    }, {
        id: 346,
        name: "鹿野鄉",
        lat: "22.9580514",
        lng: "121.1595842"
    }, {
        id: 352,
        name: "長濱鄉",
        lat: "23.3451824",
        lng: "121.4341900"
    }, {
        id: 355,
        name: "大武鄉",
        lat: "22.4141954",
        lng: "120.9073040"
    }, {
        id: 343,
        name: "蘭嶼鄉",
        lat: "22.0269018",
        lng: "121.5415968"
    }, {
        id: 342,
        name: "綠島鄉",
        lat: "22.6620886",
        lng: "121.4901443"
    }, {
        id: 348,
        name: "海端鄉",
        lat: "23.1305611",
        lng: "121.1756856"
    }, {
        id: 354,
        name: "金峰鄉",
        lat: "22.5604145",
        lng: "120.8728615"
    }, {
        id: 344,
        name: "延平鄉",
        lat: "22.9319960",
        lng: "121.0335100"
    }, {
        id: 356,
        name: "達仁鄉",
        lat: "22.3990588",
        lng: "120.8269231"
    }]
}, {
    id: 23,
    child: [{
        id: 357,
        name: "花蓮市",
        lat: "23.9910732",
        lng: "121.6111949"
    }, {
        id: 360,
        name: "吉安鄉",
        lat: "23.9732022",
        lng: "121.5841779"
    }, {
        id: 367,
        name: "玉里鎮",
        lat: "23.3898217",
        lng: "121.3770336"
    }, {
        id: 358,
        name: "新城鄉",
        lat: "24.0327075",
        lng: "121.6043742"
    }, {
        id: 359,
        name: "秀林鄉",
        lat: "24.2258575",
        lng: "121.5370003"
    }, {
        id: 361,
        name: "壽豐鄉",
        lat: "23.8593411",
        lng: "121.5598345"
    }, {
        id: 363,
        name: "光復鄉",
        lat: "23.6350647",
        lng: "121.4227610"
    }, {
        id: 365,
        name: "瑞穗鄉",
        lat: "23.5205619",
        lng: "121.4113308"
    }, {
        id: 362,
        name: "鳳林鎮",
        lat: "23.7443841",
        lng: "121.4570447"
    }, {
        id: 369,
        name: "富里鄉",
        lat: "23.1544160",
        lng: "121.2855249"
    }, {
        id: 366,
        name: "萬榮鄉",
        lat: "23.7245744",
        lng: "121.3084088"
    }, {
        id: 368,
        name: "卓溪鄉",
        lat: "23.4040070",
        lng: "121.2168466"
    }, {
        id: 364,
        name: "豐濱鄉",
        lat: "23.5851901",
        lng: "121.5027404"
    }]
}, {
    id: 24,
    child: [{
        id: 283,
        name: "馬公市",
        lat: "23.5706269",
        lng: "119.5774616"
    }, {
        id: 288,
        name: "湖西鄉",
        lat: "23.5773682",
        lng: "119.6615055"
    }, {
        id: 287,
        name: "白沙鄉",
        lat: "23.6640444",
        lng: "119.5948541"
    }, {
        id: 284,
        name: "西嶼鄉",
        lat: "23.6054584",
        lng: "119.5136711"
    }, {
        id: 285,
        name: "望安鄉",
        lat: "23.3596967",
        lng: "119.5020698"
    }, {
        id: 286,
        name: "七美鄉",
        lat: "23.2087756",
        lng: "119.4353441"
    }]
}, {
    id: 25,
    child: [{
        id: 292,
        name: "金城鎮",
        lat: "24.4320647",
        lng: "118.3155101"
    }, {
        id: 291,
        name: "金寧鄉",
        lat: "24.4565774",
        lng: "118.3058515"
    }, {
        id: 290,
        name: "金湖鎮",
        lat: "24.4376913",
        lng: "118.4279933"
    }, {
        id: 289,
        name: "金沙鎮",
        lat: "24.4811092",
        lng: "118.4279933"
    }, {
        id: 293,
        name: "烈嶼鄉",
        lat: "24.4279737",
        lng: "118.2351192"
    }, {
        id: 294,
        name: "烏坵鄉",
        lat: "24.9911547",
        lng: "119.4542045"
    }]
}, {
    id: 26,
    child: [{
        id: 22,
        name: "南竿鄉",
        lat: "26.1534361",
        lng: "119.9306863"
    }, {
        id: 23,
        name: "北竿鄉",
        lat: "26.2245753",
        lng: "119.9982607"
    }, {
        id: 25,
        name: "東引鄉",
        lat: "26.3766670",
        lng: "120.5066670"
    }, {
        id: 24,
        name: "莒光鄉",
        lat: "25.9604777",
        lng: "119.9723303"
    }, {
        id: 256,
        name: "東沙",
        lat: "25.9606469",
        lng: "119.9726081"
    }, {
        id: 257,
        name: "南沙",
        lat: "26.1602430",
        lng: "119.9516652"
    }]
}];

export function getSectionList(state: State): FilterOption[] {
    const { region } = state;
    const key = 'section';
    const target = SECTION.find(section => section.id.toString() === region);
    if (!target)
        return [];
    return getFilterAllOption(key).concat(target.child.map(e => {
        return {
            id: e.id.toString(),
            key: key,
            name: e.name
        };
    }));
}